const configProd = Object.freeze({
  POI_SERVICE_URL: "https://poi-service-api.groundtruth.com/",
  GEO_SERVICE_URL: "https://geo-lip.groundtruth.com/",
  MAPBOX_API_TOKEN: "pk.eyJ1IjoiZ3JvdW5kdHJ1dGhpbmMiLCJhIjoiY2s2d3Zmd3h0MGd6YzNocDUxODkweXIwMCJ9.lf50KKFYqZSN9sRUJjrCNw",
  MAPBOX_ACCOUNT: "mapbox://groundtruthinc.",
  MAPBOX_STYLE_URL: "mapbox://styles/groundtruthinc/ckkm747lx4haj17mi816pmlha",
  SENTRY_DSN: "https://4180fc01b44b4d0abedfee10b4637849@apps-sentry.groundtruth.com/4",
  SENTRY_ENABLED: true,
  USER_ID: 71875,
  API_KEY: "l_$x9XIeDxT9j]G'",
});

const configDev = Object.freeze({
  POI_SERVICE_URL: "https://poi-service-api-np.groundtruth.com/",
  GEO_SERVICE_URL: "https://geo-lip-np.groundtruth.com/",
  MAPBOX_API_TOKEN: "pk.eyJ1IjoiZ3JvdW5kdHJ1dGhpbmMtbnAiLCJhIjoiY2thYmtqcmUwMWh2YjJ6bXg3YjUxbmE5NCJ9.LJ9kxO5yQUXy1ayVWlQJEA",
  MAPBOX_ACCOUNT: "mapbox://groundtruthinc-np.",
  MAPBOX_STYLE_URL: "mapbox://styles/groundtruthinc-np/ckbmcvq471anj1imdsul1tqk9",
  SENTRY_DSN: "https://4180fc01b44b4d0abedfee10b4637849@apps-sentry.groundtruth.com/4",
  SENTRY_ENABLED: false,
  USER_ID: "67935",
  API_KEY: "-b_^l$kYjIx-$!&>",
});

const CONFIG = {
  prod: configProd,
  dev: configDev,
};

export default CONFIG;
